import React from 'react'
import {Tabs, Tab} from 'react-bootstrap' // DropdownButton, MenuItem, ButtonToolbar, FormControl, Button
import FontAwsome from 'react-fontawesome'
import {connect} from 'react-redux'
import AssetVehicleDocGenForm from './AssetVehicleDocGenForm'
// import WorkDocCheckCarDoc from '../workdoc/WorkDocCheckCarDoc'
import AssetVehicleServiceDoc from '../AssetVehicleServiceDoc'
// import SWTWorkNote from '../workdoc/SWTWorkNote'
// import WorkDocAttachmentDoc from '../workdoc/WorkDocAttachmentDoc'
// import WorkDocTimeline from '../workdoc/WorkDocTimeline'
import WorkdocStore from 'stores/WorkdocStore'
import { Box } from 'reactjs-admin-lte'
import {Switch,Route,withRouter} from 'react-router-dom'
import ConfirmPopup from 'component/element/ConfirmPopup'
import AssetVehicleDocFixingPage from './AssetVehicleDocFixingPage'
const NotificationSystem = require('react-notification-system')
// const ITEM = {
//     added_by: "aow@demo",
//     added_date: "0000-00-00 00:00:00",
//     brand: "HINO",
//     cost_per_unit: "20000",
//     driver_name: "",
//     employee_id: null,
//     head_registration_no: "",
//     last_mileage: "0",
//     location: "",
//     model: "S300",
//     remark: null,
//     tail_registration_no: "",
//     thumbnail_url: null,
//     total_wheel: "0",
//     trash_flag: "0",
//     vehicle_id: "1",
//     vehicle_no: "",
//     vehicle_registration_no: "AB-1234",
//     vehicle_type: "หัวลาก"
// }
class AssetVehicleDoc extends React.Component {

  constructor(...args) {
    super(...args);

    // this.state = {activeKey:'info',loading:false,showInput:false,isEdit:false,_value:this.props.workNo,_workNo:this.props.workNo}
    this.state = {
        activeKey:'info',
        loading:false,
        showInput:false,
        isEdit:false,
        _value:this.props.workNo,
        _workNo:this.props.workNo,
        showConfirm:false,
        showConfirmStatus:false,
        confirmStatus:undefined,
        showConfirmPayment:false,
        confirmPayment:undefined,
        vehicle_id:'',
        vehicle_registration_no:''
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.setTab()
    if(this.props.showInfoOnly){
        this.setVehicleId(this.props.vehicleId)
    }
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.showTb&&newProps.showTb!==this.props.showTb&&newProps.action==='add') {
        this.onTabsSelect('info')
        this.setVehicleId('')
    } else if (!newProps.showTb&&newProps.showTb!==this.props.showTb&&newProps.action==='') {
        this.onTabsSelect('info')
        this.setVehicleId(newProps.vehicleId)
    }
  }

  setVehicleId(id) {
    this.setState({vehicle_id:id})
  }

  setTab() {
    let {location} = this.props
    if (location.pathname.search('/vehicle/work/tyre')!==-1)
        this.onTabsSelect('tyre')
    // else if (location.pathname.search('/work/note')===-1)
    //     this.onTabsSelect('note')
    // else if (location.pathname.search('/work/attachment')===-1)
    //     this.onTabsSelect('attachment')
    else if (location.pathname.search('/vehicle/work/info')!==-1)
        this.onTabsSelect('info')
  }

  onTabsSelect(key) {
    this.setState({activeKey:key})
    this.props.history.push({pathname:'/vehicle/work/'+key,search: '?workNo='+this.props.workNo,state: { workNo:this.props.workNo }})
  }

  onWoChange(e) {
    let {_workNo,_value} = this.state
    _value = e.target.value
    if (_value===_workNo) {
        this.setState({isEdit:false})
    } else {
        this.setState({isEdit:true})
    }
    this.setState({_value:_value})
  }

  onWoSaveClick() {
    this.setState({showConfirm:true})
  }

  onConfirm() {
    let {_value,_workNo} = this.state
    let postData = {new_val:_value,old_val:_workNo}
    WorkdocStore.saveRenameDoc(postData,(result)=>{
        if (result.status==='OK') {
            this.setState({_workNo:_value,isEdit:false,showInput:false,showConfirm:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'ทำรายการสำเร็จ',
                level: 'info',
                position: 'tc'
            });
        }
    },(fail)=>{
        if (fail.status==='ERROR') {
            this.setState({_value:_workNo,isEdit:false,showInput:false,showConfirm:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: fail.result,
                level: 'error',
                position: 'tc'
            });
        }    
    })
  }

  onStatusSelect(key) {
    if (key==='doc_fixing'||key==='wait_for_customer'||key==='doc_job_done') {
        this.setState({confirmStatus:key,showConfirmStatus:true})
    } else if (key==='doc_credit_pay') {
        this.setState({confirmPayment:key,showConfirmPayment:true})
    }
  }

  onConfirmStatus() {
    let {confirmStatus,_workNo} = this.state
    let status = (confirmStatus==='doc_fixing'?'1':confirmStatus==='wait_for_customer'?'2':confirmStatus==='doc_job_done'?'3':'')
    let postData = {wo:_workNo,status:status}
    WorkdocStore.saveWorkStatus(postData,(result)=>{
        if (result.status==='OK') {
            this.setState({confirmStatus:undefined,showConfirmStatus:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'ทำรายการเปลี่ยนสถานะสำเร็จ',
                level: 'info',
                position: 'tc'
            });
        }
    },()=>{
        this.setState({confirmStatus:undefined,showConfirmStatus:false})
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ทำรายการไม่สำเร็จ',
            level: 'error',
            position: 'tc'
        });    
    })
  }

  onConfirmPayment() {
    let {_workNo} = this.state
    let postData = {wo:_workNo}
    WorkdocStore.saveWorkPaymentStatus(postData,(result)=>{
        if (result.status==='OK') {
            this.setState({confirmPayment:undefined,showConfirmPayment:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'ทำรายการเปลี่ยนสถานะการชำระเงินสำเร็จ',
                level: 'info',
                position: 'tc'
            });
        }
    },()=>{
        this.setState({confirmPayment:undefined,showConfirmPayment:false})
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ทำรายการไม่สำเร็จ',
            level: 'error',
            position: 'tc'
        });    
    })
  }

  onFormChange(formData){
    if(formData.vehicle !==undefined&& formData.vehicle.vehicle_registration_no!==undefined)
        this.setState({vehicle_registration_no:formData.vehicle.vehicle_registration_no})
  }

  onUpdateVehicleId(vehicleId) {
      this.setState({vehicle_id:vehicleId})
  }

  onClose(){
    this.props.onClose()

    //Push History
    this.props.history.push({pathname:'/work/info',state: { workNo:'' }})          
  }

  renderTab0() {
      let vehicleId = this.props.showInfoOnly?this.props.vehicleId:this.state.vehicle_id
      return(
            <div style={{padding:'10px'}}>
                <AssetVehicleDocGenForm
                    ref='assetVehicleDocGenForm'
                    showInfoOnly={this.props.showInfoOnly}
                    readOnly={this.props.readOnly}
                    editMode={this.props.editMode}
                    vehicleId={vehicleId}
                    show={this.props.showTb?false:true}
                    workNo={this.props.workNo}
                    onClose={this.onClose.bind(this)}
                    onFormChange={this.onFormChange.bind(this)}
                    onUpdateVehicleId={this.onUpdateVehicleId.bind(this)}
                />
            </div>
      )
  }

//   renderTab1() {
//     return(
//           <div style={{padding:'10px'}}>
//                 <WorkDocCheckCarDoc
//                     workNo={this.props.workNo}
//                 />
//           </div>
//     )
//   }
  
  renderTab2() {
    return(
          <div style={{padding:'10px'}}>
                <AssetVehicleServiceDoc
                    mode='tyre-asset-vehicle-doc'
                    vehicleId={this.state.vehicle_id}
                    workNo={this.props.workNo}
                    onClose={this.onClose.bind(this)}
                />
          </div>
    )
  }

  renderTabFixing(){
      let {vehicle_id} = this.state
      return (
          <div>
              <AssetVehicleDocFixingPage vehicleId={vehicle_id}/>
          </div>
      )
  }

//   renderTab3() {
//     return(
//           <div style={{padding:'10px'}}>
//                 <SWTWorkNote
//                     workNo={this.props.workNo}
//                 />
//           </div>
//     )
//   }

//   renderTab4() {
//     return(
//           <div style={{padding:'10px'}}>
//                 <WorkDocAttachmentDoc
//                     workNo={this.props.workNo}
//                 />
//           </div>
//     )
//   }

//   renderTab5() {
//     return(
//           <div style={{padding:'10px'}}>
//                 <WorkDocTimeline
//                     workNo={this.props.workNo}
//                 />
//           </div>
//     )
//   }

  render() {
    let {activeKey,loading,showConfirm,showConfirmStatus,confirmStatus,showConfirmPayment,confirmPayment} = this.state
    let {action} = this.props
    let titleTab0 = (<div><FontAwsome name="car" />&nbsp;ข้อมูลทั่วไป</div>)
    // let titleTab1 = (<div><FontAwsome name="wrench" />&nbsp;ตรวจรับรถก่อนซ่อม</div>)
    let titleTab2 = (<div><FontAwsome name="warning" />&nbsp;ประวัติรับบริการ</div>)
    // let titleTab3 = (<div><FontAwsome name="book" />&nbsp;บันทึกช่วยจำ</div>)
    // let titleTab4 = (<div><FontAwsome name="archive" />&nbsp;รูปประกอบ</div>)
    // let titleTab5 = (<div><FontAwsome name="calendar-check-o" />&nbsp;บันทึกเหตุการณ์</div>)
    // let titleMenu0 = (<span><FontAwsome name="print" />&nbsp;พิมพ์เอกสาร</span>)
    // let titleMenu1 = (<span><FontAwsome name="list" />&nbsp;เปลี่ยนสถานะ</span>)
    // let titleTabFixing= (<span><FontAwsome name="list" />&nbsp;ประวัติงานซ่อม</span>)
    return(
        <div>
            {/* <div className='assetwork-content-header' style={{marginBottom:'15px'}}>
                <h1 style={{display:'flex'}}>
                    ข้อมูลยานพาหนะ&nbsp;ทะเบียน&nbsp;                    
                    <span >{vehicle_registration_no}</span>                    
                </h1>
            </div> */}
            <Box loading={loading}>
                {/* <Box.Header border={false} className='text-center'>
                    <Box.Title>ใบงานซ่อมรถ <span className="label label-default">เริ่มต้น</span> <span className="label label-pink">เครดิตยังไม่ชำระเงิน</span></Box.Title>
                    <Box.Tools className='pull-right'>
                        <ButtonToolbar>
                            <DropdownButton className='bg-maroon' title={titleMenu0} id={'work-doc-entry-view-print-options'} onSelect={()=>{}}>
                                <MenuItem key={0} eventKey="checkingcar_doc">ใบตรวจสภาพรถก่อนซ่อม</MenuItem>
                                <MenuItem key={1} divider />
                                <MenuItem key={2} eventKey="checkingdamage_doc">รายการตรวจสอบความเสียหาย</MenuItem>
                                <MenuItem key={3} eventKey="fixinglistoncar_doc">รายการซ่อมติดหน้ารถ</MenuItem>            
                            </DropdownButton>
                            <DropdownButton bsStyle={'primary'} title={titleMenu1} id={'work-doc-entry-view-menu-options'} onSelect={this.onStatusSelect.bind(this)}>
                                <MenuItem key={0}>เปลี่ยนสถานะงานซ่อมเป็น</MenuItem>
                                <MenuItem key={1} eventKey="doc_fixing"><FontAwsome name='wrench' className='text-yellow'/>&nbsp;อยู่ระหว่างซ่อม</MenuItem>
                                <MenuItem key={2} eventKey="wait_for_customer"><FontAwsome name='calendar-minus-o' className='text-blue'/>&nbsp;ส่งมอบรถให้ลูกค้า</MenuItem>
                                <MenuItem key={3} eventKey="doc_job_done"><FontAwsome name='thumbs-o-up' className='text-green'/>&nbsp;ปิดจบงาน (แก้เอกสารไม่ได้)</MenuItem>
                                <MenuItem key={4} divider />
                                <MenuItem key={5}>เปลี่ยนสถานะชำระเงิน (เครดิต)</MenuItem>
                                <MenuItem key={6} eventKey="doc_credit_pay"><FontAwsome name='money' className='text-blue'/>&nbsp;ชำระเงินแล้ว</MenuItem>            
                            </DropdownButton>
                        </ButtonToolbar>
                    </Box.Tools>
                </Box.Header> */}
                <Box.Body>
                    {this.props.showInfoOnly?(this.renderTab0()):(
                    <Tabs 
                        // defaultActiveKey={'info'} 
                        activeKey={activeKey}
                        id='asset-vehicle-tabs'
                        onSelect={this.onTabsSelect.bind(this)}
                    >
                        <Switch>
                            <Route exact path="/vehicle/work/info" render={(props) => this.renderTab0()}/>                            
                            {/* <Route exact path="/work/checkcar" render={(props) => this.renderTab1()}/> */}
                            {action!=='add'?<Route exact path="/vehicle/work/tyre" render={(props) => this.renderTab2()}/>:''}
                            {/* <Route exact path="/work/note" render={(props) => this.renderTab3()}/>
                            <Route exact path="/work/attachment" render={(props) => this.renderTab4()}/> */}
                            {/* <Route exact path="/work/timeline" render={(props) => this.renderTab5()}/> */}
                            {/* <Route exact path="/vehicle/work/fixing" render={(props) => this.renderTabFixing()}/>  */}
                            <Route render={(props) => this.renderTab0()}/>                         
                        </Switch>
                        <Tab eventKey={'info'} title={titleTab0}></Tab>
                        {/* <Tab eventKey={'checkcar'} title={titleTab1}></Tab> */}
                        {action!=='add'?<Tab eventKey={'tyre'} title={titleTab2}></Tab>:''}
                        {/* <Tab eventKey={'note'} title={titleTab3}></Tab>
                        <Tab eventKey={'attachment'} title={titleTab4}></Tab> */}
                        {/* <Tab eventKey={'fixing'} title={titleTabFixing}></Tab>  */}
                    </Tabs>)}
                </Box.Body>
            </Box>
            <ConfirmPopup
                show={showConfirm}
                message='ยืนยันการแก้ไขเลขที่ใบงาน ?'
                onConfirm={this.onConfirm.bind(this)}
                onHide={()=>{this.setState({showConfirm:false})}}
            />
            <ConfirmPopup
                show={showConfirmStatus}
                message={'ต้องการเปลี่ยนสถานะเป็น '+(confirmStatus==='doc_fixing'?'อยู่ระหว่างซ่อม':confirmStatus==='wait_for_customer'?'ส่งมอบรถให้ลูกค้า':confirmStatus==='doc_job_done'?'ปิดจบงาน':'')+' ?'}
                onConfirm={this.onConfirmStatus.bind(this)}
                onHide={()=>{this.setState({showConfirmStatus:false,confirmStatus:undefined})}}
            />
            <ConfirmPopup
                show={showConfirmPayment}
                message={'ต้องการเปลี่ยนสถานะชำระเงินเป็น '+(confirmPayment==='doc_credit_pay'?'ชำระเงินแล้ว':'')+' ?'}
                onConfirm={this.onConfirmPayment.bind(this)}
                onHide={()=>{this.setState({showConfirmPayment:false,confirmPayment:undefined})}}
            />
            <NotificationSystem ref="notificationSystem" />
        </div>
    )
  }
}

AssetVehicleDoc.defaultProps = {
  onClose : ()=>{},
  action: '',
  editMode:false,
  showInfoOnly:false,
  readOnly:false
}

const mapStateToProps = (state) => ({
  store: state,
});


const _Connect = connect(
    mapStateToProps
)(AssetVehicleDoc);

export default withRouter(_Connect) 
//export default _Connect;



// WEBPACK FOOTER //
// ./src/view/tyre/report-asset-vehicle-page/AssetVehicleDoc.js